module.exports = __webpack_public_path__ + "img/programme7.8f23abe4.png";